import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { LoadingComponent } from "src/app/shared/loading/loading.component";
import { FileViewComponent } from "src/app/shared/file-view/file-view.component";
import { SecondsToHoursPipe } from "src/app/shared/pipes/seconds-to-hours.pipe";
import { BackArrowComponent } from "src/app/shared/back-arrow/back-arrow.component";
import { CalendarComponent } from "src/app/shared/calendar/calendar.component";
import { ParseCalendarDatePipe } from "src/app/shared/pipes/parse-calendar-date.pipe";
import { PickerComponent } from "src/app/shared/picker/picker.component";
import { PickerSymbolOptionsComponent } from "src/app/shared/picker/components/picker-symbol-options/picker-symbol-options.component";
import { HeaderComponent } from "src/app/shared/header/header.component";
import { SetProjectFilterDatePipe } from "src/app/employee/projects/pipes/set-project-filter-date.pipe";
import { EventTimePipe } from "src/app/employee/projects/pipes/event-time.pipe";
import { ProjectDescriptionPipe } from "src/app/employee/projects/pipes/project-description.pipe";
import { DateTimePickerComponent } from "src/app/shared/date-time-picker/date-time-picker.component";
import { ParseCardDatePipe } from "src/app/shared/pipes/parse-card-date.pipe";
import { LinkifyPipe } from "src/app/shared/pipes/linkify.pipe";
import { ApactaButtonComponent } from "src/app/shared/apacta-button/apacta-button.component";
import { PreventDoubleClickDirective } from "src/app/shared/prevent-double-click/prevent-double-click.directive";
import { MarkdownPipe } from "src/app/shared/pipes/markdown.pipe";
import { MarkdownRemoverPipe } from "src/app/shared/pipes/markdown-remover.pipe";
import { ShowPasswordDirective } from "src/app/shared/show-password/show-password.directive";
import { PhoneNumberPipe } from "src/app/shared/pipes/phone-number.pipe";
import { LabelsComponent } from "src/app/shared/labels/labels.component";
import { VendorsComponent } from "src/app/shared/vendors/vendors.component";
import { Signature } from "src/app/shared/signature/signature.component";
import { PrintAddressPipe } from "src/app/shared/pipes/print-address.pipe";

@NgModule({
    declarations: [
        LoadingComponent,
        ApactaButtonComponent,
        FileViewComponent,
        SecondsToHoursPipe,
        BackArrowComponent,
        CalendarComponent,
        ParseCalendarDatePipe,
        PickerComponent,
        PickerSymbolOptionsComponent,
        HeaderComponent,
        SetProjectFilterDatePipe,
        EventTimePipe,
        ProjectDescriptionPipe,
        DateTimePickerComponent,
        ParseCardDatePipe,
        LinkifyPipe,
        PhoneNumberPipe,
        MarkdownPipe,
        MarkdownRemoverPipe,
        PreventDoubleClickDirective,
        ShowPasswordDirective,
        LabelsComponent,
        VendorsComponent,
        Signature,
        PrintAddressPipe,
    ],
    imports: [CommonModule, IonicModule, FormsModule, TranslateModule],
    exports: [
        ApactaButtonComponent,
        LoadingComponent,
        SecondsToHoursPipe,
        BackArrowComponent,
        CalendarComponent,
        FormsModule,
        PickerComponent,
        PickerSymbolOptionsComponent,
        HeaderComponent,
        SetProjectFilterDatePipe,
        EventTimePipe,
        ProjectDescriptionPipe,
        DateTimePickerComponent,
        ParseCardDatePipe,
        LinkifyPipe,
        PhoneNumberPipe,
        MarkdownPipe,
        MarkdownRemoverPipe,
        PreventDoubleClickDirective,
        ShowPasswordDirective,
        Signature,
        PrintAddressPipe,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
